import { getNowTime } from './utils/time';
import { getSessionManager } from './helpers';
export function getTiming(duration) {
    if (typeof duration === 'number') {
        return duration;
    }
    return getNowTime() - getSessionManager().currentPageTimestamp;
}
